module.exports = __webpack_public_path__ + "img/headerbg.c35e9c67.webp";